const initialState = {
    corporatePermissionsApproval: {},
    corporateListsApproval: [],
    corporateDetailsApproval: [],
    corporateViewDetailsApproval: [],
    corporateStatusApproval: [],
    changedCorporateStatusApproval: [],
    corporateIDApproval:null,
    loadingCorporateApproval: false,
    loadingCorporateSocialApproval: false,
    loadingCorporateVerificationApproval: false,
    loadingCorporateCompanyDetailApproval: false,
    loadingCorporateAlertApproval: false,
    loadingCorporateGrievanceApproval: false,
    loadingBlacklistCorporateApproval: false,
    errorsCorporateApproval: {},
    errorsCorporateSocialApproval: {},
    errorsCorporateVerificationApproval: {},
    errorsCorporateCompanyDetailApproval: {},
    errorsCorporateAlertApproval: {},
    errorsCorporateGrievanceApproval: {},
    errorsBlacklistCorporateApproval: {},
}

const corporateApprovalReducer = (state = initialState, action) => {
    switch (action.type) {
        case "GET_CORPORATELIST_PENDING_APPROVAL":
        case "ADD_CORPORATE_PENDING_APPROVAL":
        case "UPDATE_CORPORATE_PENDING_APPROVAL":
        case "UPDATE_CORPORATE_STATUS_PENDING_APPROVAL":
        case "UPDATE_CORPORATE_SOCIALMEDIA_PENDING_APPROVAL":
        case "DELETE_CORPORATE_PENDING_APPROVAL":
        case "GET_CORPORATELISTBYID_PENDING_APPROVAL":
        case "GET_CORPORATEVIEWBYID_PENDING_APPROVAL":
            return { ...state, loadingCorporateApproval: true };
        case "CORPORATE_VERIFICATION_PENDING_APPROVAL":
            return { ...state, loadingCorporateVerificationApproval: true };
        case "CORPORATE_COMAPNYDETAILS_PENDING_APPROVAL":
            return { ...state, loadingCorporateCompanyDetailApproval: true };
        case "CORPORATE_ALERT_PENDING_APPROVAL":
            return { ...state, loadingCorporateAlertApproval: true };
        case "CORPORATE_GRIEVANCE_PENDING_APPROVAL":
            return { ...state, loadingCorporateGrievanceApproval: true };
        case "CORPORATE_BLACKLIST_PENDING_APPROVAL":
            return { ...state, loadingBlacklistCorporateApproval: true };

        case "GET_CORPORATELIST_FULFILLED_APPROVAL":
            return {
                ...state,
                loadingCorporateApproval: false,
                corporateListsApproval: action.payload,
                corporateCountApproval: action.count,
                corporatePermissionsApproval: action.permissions,
            };

        case "ADD_CORPORATE_FULFILLED_APPROVAL":
            return {
                ...state,
                loadingCorporateApproval: false,
                changedCorporateStatusApproval: action.payload,
                corporateIDApproval:action.payload.data.id,
            };

        case "UPDATE_CORPORATE_FULFILLED_APPROVAL":
            return {
                ...state,
                loadingCorporateApproval: false,
                changedCorporateStatusApproval: action.payload,
            };

        case "UPDATE_CORPORATE_STATUS_FULFILLED_APPROVAL":
            return {
                ...state,
                loadingCorporateApproval: false,
                changedCorporateStatusApproval: action.payload,
            };

        case "GET_CORPORATELISTBYID_FULFILLED_APPROVAL":
            return {
                ...state,
                loadingCorporateApproval: false,
                corporateDetailsApproval: action.payload
            };

        case "GET_CORPORATEVIEWBYID_FULFILLED_APPROVAL":
            return {
                ...state,
                loadingCorporateApproval: false,
                corporateViewDetailsApproval: action.payload
            };

        case "DELETE_CORPORATE_FULFILLED_APPROVAL":
            return {
                ...state,
                loadingCorporateApproval: false,
                changedCorporateStatusApproval: action.payload
            };

        case "RESET_DELETE_CORPORATES_STATUS_APPROVAL":
            return {
                ...state,
                loadingCorporateApproval: false,
                changedCorporateStatusApproval: [],
                errorsCorporateApproval: {}
            };

        case "GET_CORPORATELIST_REJECTED_APPROVAL":
        case "ADD_CORPORATE_REJECTED_APPROVAL":
            return {
                ...state,
                loadingCorporateApproval: false,
                changedCorporateStatusApproval: [],
                errorsCorporateApproval: action.payload
            };
        case "UPDATE_CORPORATE_SOCIALMEDIA_FULFILLED_APPROVAL":
            return {
                ...state,
                loadingCorporateSocialApproval: false,
                changedCorporateStatusApproval: action.payload,
                errorsCorporateSocialApproval: {}
            };
        case "CORPORATE_VERIFICATION_FULFILLED_APPROVAL":
            return {
                ...state,
                loadingCorporateVerificationApproval: false,
                changedCorporateStatusApproval: action.payload,
                errorsCorporateVerificationApproval: {}
            };
        case "CORPORATE_COMAPNYDETAILS_FULFILLED_APPROVAL":
            return {
                ...state,
                loadingCorporateCompanyDetailApproval: false,
                changedCorporateStatusApproval: action.payload,
                errorsCorporateCompanyDetailApproval: {}
            };
        case "CORPORATE_ALERT_FULFILLED_APPROVAL":
            return {
                ...state,
                loadingCorporateAlertApproval: false,
                changedCorporateStatusApproval: action.payload,
                errorsCorporateAlertApproval: {}
            };
        case "CORPORATE_GRIEVANCE_FULFILLED_APPROVAL":
            return {
                ...state,
                loadingCorporateGrievanceApproval: false,
                changedCorporateStatusApproval: action.payload,
                errorsCorporateGrievanceApproval: {}
            };
        case "CORPORATE_BLACKLIST_FULFILLED_APPROVAL":
            return {
                ...state,
                loadingBlacklistCorporateApproval: false,
                changedCorporateStatusApproval: action.payload,
                errorsBlacklistCorporateApproval: {}
            };
        case "UPDATE_CORPORATE_REJECTED_APPROVAL":
        case "UPDATE_CORPORATE_STATUS_REJECTED_APPROVAL":
        case "DELETE_CORPORATE_REJECTED_APPROVAL":
        case "GET_CORPORATELISTBYID_REJECTED_APPROVAL":
        case "GET_CORPORATEVIEWBYID_REJECTED_APPROVAL":
            return {
                ...state,
                loadingCorporateApproval: false,
                errorsCorporateApproval: action.payload
            };
        case "UPDATE_CORPORATE_SOCIALMEDIA_REJECTED_APPROVAL":
            return {
                ...state,
                loadingCorporateSocialApproval: false,
                errorsCorporateSocialApproval: action.payload
            };
        case "CORPORATE_VERIFICATION_REJECTED_APPROVAL":
            return {
                ...state,
                loadingCorporateVerificationApproval: false,
                errorsCorporateVerificationApproval: action.payload
            };
        case "CORPORATE_COMAPNYDETAILS_REJECTED_APPROVAL":
                return {
                    ...state,
                    loadingCorporateCompanyDetailApproval: false,
                    changedCorporateStatusApproval: [],
                    errorsCorporateCompanyDetailApproval: action.payload,
                };
        case "CORPORATE_COMAPNYDETAILS_REJECTED_APPROVAL":
                return {
                    ...state,
                    loadingCorporateAlertApproval: false,
                    changedCorporateStatusApproval: [],
                    errorsCorporateAlertApproval : action.payload,
                };
        case "CORPORATE_GRIEVANCE_REJECTED_APPROVAL":
                return {
                    ...state,
                    loadingCorporateGrievanceApproval: false,
                    changedCorporateStatusApproval: [],
                    errorsCorporateGrievanceApproval : action.payload,
                };
        case "CORPORATE_BLACKLIST_REJECTED_APPROVAL":
                return {
                    ...state,
                    loadingBlacklistCorporateApproval: false,
                    changedCorporateStatusApproval: [],
                    errorsBlacklistCorporateApproval : action.payload,
                };
        case "RESET_DELETE_CORPORATE_STATUS_APPROVAL":
                return {
                    ...state,
                    loadingCorporateCompanyDetailApproval: false,
                    changedCorporateStatusApproval: [],
                    errorsCorporateApproval: {},
                    errorsCorporateSocialApproval: {},
                    errorsCorporateVerificationApproval: {},
                    errorsCorporateCompanyDetailApproval: {},
                    errorsCorporateAlertApproval: {},
                    errorsCorporateGrievanceApproval: {},
                    errorsBlacklistCorporateApproval: {}
                };

        case "CLEAR_CORPORATE_DETAILS_APPROVAL":
                return {
                    ...state,
                    corporateDetailsApproval: {},
                    corporateViewDetailsApproval: {},
                    corporateIDApproval: null
                };

        default:
            return state;
    }
}

export default corporateApprovalReducer;